<div class="container-fluid lrd-viewport">

    <!-- Back Button -->
    <button class="btn-back" (click)="goBack()">
        <i class="fas fa-arrow-left"></i> Back
    </button>

    <!-- Loading State -->
    <div *ngIf="loaderShown" class="lrd-loading-container">
        <div class="lrd-custom-loader">
            <div class="lrd-loader-emblem-container">
                <img src="assets/img/logo.png" alt="Company Logo" class="lrd-loader-emblem" />
                <div class="lrd-loading-circle"></div>
            </div>
            <p class="lrd-loading-text">Loading leave request...</p>
        </div>
    </div>

    <!-- Main Card -->
    <div class="card lrd-card" *ngIf="!loaderShown && record">

        <!-- Header -->
        <div class="card-header lrd-card-header">
            <div class="lrd-header-left">
                <div>
                    <h2 class="mb-0">Leave Request Detail</h2>
                    <p class="lrd-subtitle mb-0">Full details of the submitted leave application</p>
                </div>
            </div>

            <div class="lrd-header-actions" *ngIf="record.status === 'Pending' || record.status === 'Pre approved'">
                <button class="lrd-btn-preapprove" *ngIf="record.status === 'Pending'" (click)="preApprove()">
                    <i class="fas fa-thumbs-up me-1"></i> Pre Approve
                </button>
                <button class="lrd-btn-approve" (click)="approve()">
                    <i class="fas fa-check me-1"></i> Approve
                </button>
                <button class="lrd-btn-reject" (click)="reject()">
                    <i class="fas fa-times me-1"></i> Reject
                </button>
            </div>
        </div>

        <!-- Body -->
        <div class="card-body lrd-body">

            <!-- Employee Hero Section -->
            <div class="lrd-hero">
                <div class="lrd-hero-info">
                    <h3 class="lrd-emp-name">{{ record.employee_name || '—' }}</h3>
                    <span class="lrd-emp-dept">{{ record.department_name || 'No Department' }}</span>
                </div>
                <div class="lrd-hero-badge">
                    <span class="lrd-status-badge" [ngClass]="getStatusBadge(record.status)">
                        <i class="fas" [ngClass]="getStatusIcon(record.status)"></i>
                        {{ record.status }}
                    </span>
                </div>
            </div>

            <!-- Info Grid -->
            <div class="lrd-grid">

                <!-- Leave Type -->
                <div class="lrd-info-card">
                    <div class="lrd-info-label">
                        <i class="fas fa-tag me-1"></i> Leave Type
                    </div>
                    <div class="lrd-info-value">
                        <span class="lrd-type-badge" [ngClass]="getLeaveTypeBadge(record.leave_type)">
                            {{ record.leave_type || '—' }}
                        </span>
                        <span *ngIf="record.is_marriage_leave"
                            class="lrd-type-badge lrd-badge--marriage-type d-block mt-1">
                            <i class="fas fa-ring"></i> Marriage Leave
                        </span>
                    </div>
                </div>

                <!-- From Date -->
                <div class="lrd-info-card">
                    <div class="lrd-info-label">
                        <i class="fas fa-calendar-alt me-1"></i> From Date
                    </div>
                    <div class="lrd-info-value lrd-date-val">{{ DateFormat(record.from_date) }}</div>
                </div>

                <!-- To Date -->
                <div class="lrd-info-card">
                    <div class="lrd-info-label">
                        <i class="fas fa-calendar-check me-1"></i> To Date
                    </div>
                    <div class="lrd-info-value lrd-date-val">{{ DateFormat(record.to_date) }}</div>
                </div>

                <!-- Duration -->
                <div class="lrd-info-card">
                    <div class="lrd-info-label">
                        <i class="fas fa-hourglass-half me-1"></i> Duration
                    </div>
                    <div class="lrd-info-value">
                        <span class="lrd-days-pill">{{ calcDays(record.from_date, record.to_date) }}</span>
                    </div>
                </div>

                <!-- Applied On -->
                <div class="lrd-info-card" *ngIf="record.created_at || record.createdAt">
                    <div class="lrd-info-label">
                        <i class="fas fa-paper-plane me-1"></i> Applied On
                    </div>
                    <div class="lrd-info-value lrd-date-val">{{ DateFormat(record.created_at || record.createdAt) }}
                    </div>
                </div>

                <!-- Approved By -->
                <div class="lrd-info-card">
                    <div class="lrd-info-label">
                        <i class="fas fa-user-check me-1"></i> Actioned By
                    </div>
                    <div class="lrd-info-value">{{ record.approved_by?.employee_name || '—' }}</div>
                </div>

            </div>

            <!-- Reason -->
            <div class="lrd-section">
                <div class="lrd-section-label">
                    <i class="fas fa-comment-alt me-1"></i> Reason for Leave
                </div>
                <div class="lrd-reason-box">
                    {{ record.reason || 'No reason provided.' }}
                </div>
            </div>

            <!-- Rejection Reason (shown only when rejected) -->
            <div class="lrd-section"
                *ngIf="record.status === 'Rejected' && (record.reject_reason || record.decline_reason)">
                <div class="lrd-section-label lrd-section-label--danger">
                    <i class="fas fa-ban me-1"></i> Rejection Reason
                </div>
                <div class="lrd-reason-box lrd-reason-box--danger">
                    {{ record.reject_reason || record.decline_reason }}
                </div>
            </div>

        </div>
    </div>

    <!-- Not Found -->
    <div class="lrd-empty" *ngIf="!loaderShown && !record">
        <i class="fas fa-calendar-times"></i>
        <p>Leave request not found</p>
        <button class="lrd-btn-back-empty" (click)="goBack()">Go Back</button>
    </div>

</div>